module.exports = __webpack_public_path__ + "static/media/play.43ac80e5.svg";